module.exports = __webpack_public_path__ + "img/code-jquery-lg.b26bcfe0.webp";